import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from "@angular/core";

@Directive({
	selector: "[focusClick]",
})
export class FocusClickDirective {
	@Input() disabled = false;

	@Output() focusClick = new EventEmitter<void | Event>();

	@HostBinding("attr.tabindex") tabIndex = 0;

	@HostListener("click", ["$event"])
	isClicked(event: Event) {
		if (!this.disabled) {
			this.focusClick.emit(event);
		}
	}

	@HostListener("keydown.enter")
	isEntered() {
		if (!this.disabled) {
			this.focusClick.emit();
		}
	}
}
